import routerOptions0 from "/builds/bounsel/flow/frontend/app-flow/node_modules/.pnpm/nuxt@3.7.0_@types+node@20.5.1_eslint@8.51.0_rollup@3.29.4_sass@1.57.1_typescript@4.9.5_vue-tsc@1.0.24/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}